import { BulkSpreadsheet, parseBool, parseNum, type BulkColumn } from '../shared/BulkSpreadsheet';
import { bankTransactionService } from '@kss/api';
import type { BankTransactionCreate } from '@kss/api';
import { loadStoreOptions, loadAccountOptions } from '../shared/formLoaders';

const columns: BulkColumn<BankTransactionCreate>[] = [
  { key: 'transactionDate', header: 'Date', required: true, dataType: 'date', sample: new Date().toISOString().slice(0, 10) },
  { key: 'amount', header: 'Amount', dataType: 'number', parse: parseNum as never, required: true, sample: '1000' },
  { key: 'type', header: 'Type', sample: 'Credit' },
  { key: 'reference', header: 'Reference' },
  { key: 'description', header: 'Description' },
  { key: 'accountId', header: 'Account', dataType: 'lookup', loadOptions: loadAccountOptions },
  { key: 'storeId', header: 'Store', dataType: 'lookup', loadOptions: loadStoreOptions },
  { key: 'isReconciled', header: 'Reconciled', dataType: 'boolean', parse: parseBool as never, sample: 'false' },
  { key: 'isActive', header: 'Active', dataType: 'boolean', parse: parseBool as never, sample: 'true' },
];

export default function BulkBankTransaction() {
  return (
    <BulkSpreadsheet<BankTransactionCreate> title="Bulk import bank transactions" entityLabel="transaction" backPath="/panel/bank-transactions" columns={columns} module="BankTransaction"
      onImport={async (rows) => {
        const payload = rows.map((r) => ({ ...r, amount: Number(r.amount ?? 0), isActive: r.isActive ?? true }));
        const created = await bankTransactionService.create(payload);
        return { created: Array.isArray(created) ? created.length : payload.length };
      }}
    />
  );
}
